// extracted by mini-css-extract-plugin
export default {"jobTitle":"locales_jobTitle__05bx8"};